import { Timer } from 'lucide-react';

const SLAIndicator = ({ hours, status }) => {
  const statusStyles = {
    ok: 'text-green-400 bg-green-500/20',
    warning: 'text-amber-400 bg-amber-500/20',
    critical: 'text-red-400 bg-red-500/20 animate-pulse'
  };

  const formatTime = (h) => {
    if (h < 1) return '<1h';
    if (h < 24) return `${h}h`;
    return `${Math.floor(h / 24)}d ${h % 24}h`;
  };

  return (
    <div className={`inline-flex items-center gap-1 px-2 py-1 rounded text-xs font-medium ${statusStyles[status]}`}>
      <Timer className="w-3 h-3" />
      {formatTime(hours)}
    </div>
  );
};

export default SLAIndicator;
